import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCheckoutOutboundRatesSettings = {
  name: "getCheckoutOutboundRatesSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    enabled: z.boolean(),
    demoEnabled: z.boolean(),
    hideNonRedoRatesWhenRedoPresent: z.boolean(),
    customCarrierServiceName: z.string().optional(),
    subscriptionsModeEnabled: z.boolean(),
    hideInvisibleRateNameCharsWhenPossible: z.boolean(),
    preventSplitShipmentsRateAddition: z.boolean(),
    filterFedexOneRateRates: z.boolean(),
    useShippingOptionMetafields: z.boolean(),
  }),
};
